






















































import { Component, Vue } from "vue-property-decorator";
import BaseButton from "@/components/BaseButton.vue";
import BaseInput from "@/components/BaseInput.vue";
import DocCompiler from "@/components/DocCompiler";
import WithHighlight from "@/components/WithHighlight.vue";
import { content } from "@/data/Q1-sample-text.json";
import Stickyfill from "stickyfilljs";

@Component({
  components: {
    WithHighlight,
    DocCompiler,
    BaseButton,
    BaseInput
  }
})
export default class DocWithHighlight extends Vue {
  content = content;
  query = "";
  replacement = "";
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const nav: any = document.querySelector(".nav");
    if (nav) {
      Stickyfill.add(nav);
    }
  }
}
